import React, { Component } from "react";
import Select from "react-select";
import "../../Benefits/Benefits.css";
import { toast } from "react-toastify";
import ApprovalForm from "../../Common/ApprovalForm";
import {
  main_url,
  getCookieData,
  validate,
  getActionStatus,
  havePermissionForAmount,
  getWorkFlowStatus,
  startSaving,
  getWithdrawalLocation,
  fno,
} from "../../../utils/CommonFunction";
import { getHeaders } from "../../../utils/apiHelper";
const $ = require("jquery");
var limit_amount = 40000;

class TeamBuildingAddNew extends Component {
  constructor(props) {
    super(props);
    var user_info = getCookieData("user_info");
    this.state = {
      one_benefit: this.props.data,
      quater_list: [],
      status: 0,
      createdBy: 0,
      updatedBy: 0,
      user_id: user_info.user_id,
      selected_quater: [],
      selected_location: null,
      selected_withdrawal_location: null,
      employee_list: [],
      employeeList: [],
      selectedEmployee: null,
      branchlist: [],
      withdrawalLocations: [],
      is_main_role: false,
      status_title: "",
      work_flow_status: {},
      comment: "",
      year_list: [],
      year: "",
    };
  }

  getBranchList() {
    fetch(`${main_url}benefit/getBranchList`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          branchlist: list,
        });
      });
  }

  getWithdrawalLocations = async () => {
    const withdrawalLocations = await getWithdrawalLocation();

    this.setState({
      withdrawalLocations: withdrawalLocations,
    });
  };

  getQuaterList() {
    fetch(`${main_url}team_building/getQuater`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          quater_list: list,
        });
      });
  }

  getTeamBuildingDetail(id) {
    fetch(`${main_url}team_building/getTeamBuildingDetail/${id}`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          employee_list: list,
        });
      });
  }

  async setOneBenefit(data) {
    if (!Array.isArray(data) && data !== null) {
      this.getTeamBuildingDetail(data.benefit_id);
      var work_flow = await getWorkFlowStatus(
        data.createdBy,
        this.state.user_id,
        "Team Building",
        "Benefit"
      );
      this.setState({
        selected_quater: { value: data.quater_id, label: data.quarter_name },
        selected_location: { value: data.location_id, label: data.branch_name },
        selected_withdrawal_location: !!data.withdraw_location
          ? {
              value: data.withdraw_location,
              label: data.withdrawal_location_name,
            }
          : null,
        status: data.status,
        year: { value: data.year, label: data.year },
        work_flow_status: work_flow,
        is_main_role: havePermissionForAmount(work_flow, data.createdBy),
      });
    }
  }

  componentDidMount() {
    this.getBranchList();
    this.getWithdrawalLocations();
    this.getQuaterList();
    this.getEmployeeList();
    this.setOneBenefit(this.state.one_benefit);
    this.getYearList();
  }

  getEmployeeList() {
    return fetch(`${main_url}main/getEmployeeWithDesignation/0`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          employeeList: data.map((employee) => ({
            ...employee,
            label: employee.employment_id,
            value: employee.value,
            name: employee.label,
            designation:
              employee.designations ||
              employee.designation ||
              employee.position ||
              "",
          })),
        });
      });
  }

  getEmployeeListByBranch(id) {
    fetch(`${main_url}main/getEmployeeListByBranch/${id}`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          employee_list: list,
        });
      });
  }

  handleSelectedLocation = (event) => {
    if (event !== null) this.getEmployeeListByBranch(event.value);
    this.setState({
      selected_location: event,
    });
  };

  handleSelectWithdrawalLocation = (event) => {
    this.setState({
      selected_withdrawal_location: event,
    });
  };

  handleSelectedQuater = (event) => {
    this.setState({
      selected_quater: event,
    });
  };

  handleChangeEmployee = (selectedEmployee) => {
    this.setState({ selectedEmployee });
  };

  formatEmployeeOptionLabel = (employee) => (
    <div className="team-building-employee-option">
      <span className="team-building-employee-option-primary">
        {employee.name} ({employee.employment_id})
      </span>
      {employee.designation ? (
        <span className="team-building-employee-option-position">
          {employee.designation}
        </span>
      ) : null}
    </div>
  );

  filterEmployeeOption = (option, inputValue) => {
    const searchText = String(inputValue || "")
      .trim()
      .toLowerCase();

    if (!searchText) return true;

    const employee = option.data;
    return [employee.name, employee.employment_id, employee.designation].some(
      (value) =>
        String(value || "")
          .toLowerCase()
          .includes(searchText)
    );
  };

  getSelectedEmployeeDetail() {
    const { selectedEmployee } = this.state;

    if (!selectedEmployee) return Promise.resolve([]);

    return fetch(`${main_url}team_building/getEmployee`, {
      method: "POST",
      headers: getHeaders(true),
      body: `employee_id=${JSON.stringify(selectedEmployee.value)}`,
    })
      .then((res) => {
        if (res.ok) return res.json();
        return [];
      });
  }

  addEmployeeInList = () => {
    return this.getSelectedEmployeeDetail().then((list) => {
      if (!list.length) return;

      const employee = list[0];
      const alreadyExists = this.state.employee_list.some(
        (item) =>
          (employee.user_id != null && item.user_id === employee.user_id) ||
          item.fullname === employee.fullname
      );

      if (alreadyExists) {
        toast.error(employee.fullname + " already exists in the table");
        return;
      }

      this.setState(
        (previousState) => ({
          employee_list: previousState.employee_list.concat(employee),
          selectedEmployee: null,
        }),
        () => toast.success(employee.fullname + " added successfully")
      );
    });
  };

  removeEmployeeInList = () => {
    return this.getSelectedEmployeeDetail().then((list) => {
      if (!list.length) return;

      const employee = list[0];
      const employeeExists = this.state.employee_list.some(
        (item) => item.user_id === employee.user_id
      );

      if (!employeeExists) return;

      this.setState(
        (previousState) => ({
          employee_list: previousState.employee_list.filter(
            (item) => item.user_id !== employee.user_id
          ),
          selectedEmployee: null,
        }),
        () => toast.success(employee.fullname + " removed successfully")
      );
    });
  };

  canSave() {
    const { is_main_role, one_benefit } = this.state;
    return (
      !is_main_role &&
      (one_benefit.status === undefined || Number(one_benefit.status) === 5)
    );
  }

  approvalStatus = (text, comment) => {
    this.setState({ status_title: text, comment: comment }, () => this.save());
  };

  handleAmount = (index, e) => {
    if (e.target.value > limit_amount) {
      toast.error("Your amount is too much. Please check the amount!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      var data = this.state.employee_list;
      data[index].amount = e.target.value;
      this.setState({
        employee_list: data,
      });
    }
  };

  handleAllAmount = (e) => {
    this.setState({
      all_amount: e.target.value,
    });
  };

  handleYear = (event) => {
    this.setState({
      year: event,
    });
  };

  getYearList() {
    var d = new Date();
    var lastYear = d.getFullYear();
    var previousYear = d.getFullYear() - 1;
    const options = [
      { value: lastYear, label: lastYear },
      { value: previousYear, label: previousYear },
    ];
    this.setState({
      year_list: options,
      //list.map(v => ({ ...v, label: v.branch_name, value: v.branch_id }))
    });
  }

  addAmount = () => {
    if (this.state.all_amount > limit_amount) {
      toast.error("Your amount is too much. Please check the amount!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      var data = this.state.employee_list;
      var amount = this.state.all_amount;
      for (let i = 0; i < data.length; i++) {
        data[i].amount = amount;
      }
      this.setState({
        employee_list: data,
      });
    }
  };
  save() {
    let one_benefit = this.state.one_benefit;
    let total_amount = $("#total_amount").val();
    if (validate("check_form")) {
      let { status_title, is_main_role } = this.state;
      var data = {
        location_id: this.state.selected_location.value,
        withdraw_location: this.state.selected_withdrawal_location.value,
        quater: this.state.selected_quater.value,
        year: this.state.year.value,
        // designation: this.state.designation,
        total_amount: total_amount,
        detail: this.state.employee_list,
        status:
          Number(this.state.one_benefit.status) === 5
            ? 0
            : this.state.one_benefit.status,
        form_no: !!one_benefit ? one_benefit.form_no : undefined,
      };
      let status = 0;

      if (status_title !== "" && is_main_role) {
        var action = getActionStatus(
          status_title,
          one_benefit,
          this.state.user_id,
          this.state.comment
        );
        data.referback_by = action.referback_by;
        data.checked_by = action.checked_by;
        data.verified_by = action.verified_by;
        data.approved_by = action.approved_by;
        data.rejected_by = action.rejected_by;
        data.referback_date = action.referback_date;
        data.checked_date = action.checked_date;
        data.verified_date = action.verified_date;
        data.approved_date = action.approved_date;
        data.rejected_date = action.rejected_date;
        data.referback_comment = action.referback_comment;
        data.checked_comment = action.checked_comment;
        data.verified_comment = action.verified_comment;
        data.approved_comment = action.approved_comment;
        data.status = action.status;
        data.form_no = one_benefit.form_no;
      }

      return fetch(
        `${main_url}team_building/editTeamBuilding/${one_benefit.benefit_id}`,
        {
          method: "POST",
          headers: getHeaders(true),
          body: `benefit=${JSON.stringify(data)}`,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          this.props.showToast(status, text);
        });
    } else {
      startSaving();
    }
  }

  render() {
    // console.log("selected location",this.state.selected_location,this.state.branchlist)
    this.total_amount = 0;
    var { is_main_role } = this.state;
    const canSave = this.canSave();
    const { selectedEmployee } = this.state;
    return (
      <div className="container">
        <div className="row">
          <div id="check_form">
            <div className="row team-building-edit-fields">
              <div className="col-md-6 team-building-edit-column team-building-edit-column-left">
                <div className="form-group team-building-form-field">
                  <label htmlFor="team-building-voucher-no">Voucher No.</label>
                  <input
                    id="team-building-voucher-no"
                    type="text"
                    className="form-control input-md"
                    value={fno.fno_team + this.state.one_benefit.form_no}
                    disabled
                  />
                </div>

                <div className="form-group team-building-form-field">
                  <label htmlFor="team-building-location">
                    Select Location
                  </label>
                  <Select
                    inputId="team-building-location"
                    options={this.state.branchlist}
                    placeholder="Please Choose Branch"
                    onChange={this.handleSelectedLocation.bind(this)}
                    value={this.state.selected_location}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="team-building-period-row">
                  <div className="form-group team-building-form-field">
                    <label htmlFor="team-building-year">Select Year</label>
                    <Select
                      inputId="team-building-year"
                      placeholder="Select Year"
                      options={this.state.year_list}
                      value={this.state.year}
                      onChange={this.handleYear}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>

                  <div className="form-group team-building-form-field">
                    <label htmlFor="team-building-quater">Select Quarter</label>
                    <Select
                      inputId="team-building-quater"
                      options={this.state.quater_list}
                      placeholder="Please Choose Quarter"
                      onChange={this.handleSelectedQuater.bind(this)}
                      value={this.state.selected_quater}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6 team-building-edit-column team-building-edit-column-right">
                <div className="form-group team-building-form-field">
                  <label htmlFor="team-building-withdrawal-location">
                    Select Withdrawal Location
                  </label>
                  <Select
                    inputId="team-building-withdrawal-location"
                    options={this.state.withdrawalLocations}
                    placeholder="Please Choose Withdrawal Location"
                    onChange={this.handleSelectWithdrawalLocation.bind(this)}
                    value={this.state.selected_withdrawal_location}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="team-building-amount-row">
                  <div className="form-group team-building-form-field team-building-amount-field">
                    <label htmlFor="team-building-amount">Amount</label>
                    <input
                      id="team-building-amount"
                      type="number"
                      min="0"
                      max="17500"
                      className="form-control input-md"
                      value={this.state.all_amount}
                      onChange={this.handleAllAmount.bind(this)}
                    />
                  </div>
                  <button
                    className="btn btn-primary team-building-amount-add"
                    type="button"
                    onClick={() => this.addAmount()}
                  >
                    Add
                  </button>
                </div>

                {canSave ? (
                  <div className="team-building-employee-controls">
                    <div className="form-group team-building-form-field team-building-employee-field">
                      <label htmlFor="team-building-employee">Employee</label>
                      <Select
                        inputId="team-building-employee"
                        placeholder="Select Employee"
                        options={this.state.employeeList}
                        value={selectedEmployee}
                        onChange={this.handleChangeEmployee}
                        formatOptionLabel={this.formatEmployeeOptionLabel}
                        filterOption={this.filterEmployeeOption}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="team-building-employee-actions">
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={this.addEmployeeInList}
                        disabled={!selectedEmployee}
                      >
                        Add Employee
                      </button>
                      <button
                        className="btn btn-danger"
                        type="button"
                        onClick={this.removeEmployeeInList}
                        disabled={!selectedEmployee}
                      >
                        Remove Employee
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="funeral-detail col-md-12 team-building-employee-table">
                <table className="table table-bordered table-responsive">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Employee Id</th>
                      <th>Employee Name</th>
                      <th>Position</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.employee_list.length <= 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No Data To Show
                        </td>
                      </tr>
                    ) : (
                      this.state.employee_list.map((data, index) => {
                        this.total_amount += Number(data.amount);
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.employment_id}</td>
                            <td>{data.fullname}</td>
                            <td>
                              {data.position ||
                                data.designations ||
                                data.designation}
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                onChange={this.handleAmount.bind(this, index)}
                                value={data.amount}
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                    <tr>
                      <td colSpan="4">Total Amount</td>
                      <td>{this.total_amount}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <input
              type="number"
              className="hidden"
              id="total_amount"
              value={this.total_amount}
              readOnly
            />
          </div>
        </div>

        {/* <div className="row save-btn">
                    <div className="float-right">
                        <div>
                            <button className="btn btn-primary" type="button" onClick={this.save.bind(this, this.total_amount)}>Save</button>
                        </div>

                    </div>
                </div> */}

        <div className="row save-btn">
          {is_main_role ? (
            <ApprovalForm
              approvalStatus={this.approvalStatus.bind(this)}
              status={this.state.one_benefit.status}
              work_flow={this.state.work_flow_status}
              total_amount={this.state.one_benefit.total_amount}
            />
          ) : (
            <div className="col-md-12 btn-rightend">
              {canSave ? (
                <div>
                  <button
                    onClick={this.save.bind(this)}
                    className="btn btn-primary"
                    id="saving_button"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* <button onClick={this.save.bind(this)} id="saving_button" className="btn btn-primary"><span>Save</span> </button> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TeamBuildingAddNew;
